import type { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import type { AboutAppStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type AboutAppQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const AboutAppQuizStep = ({ id, renderQuizScreen }: AboutAppQuizStepProps) => {
  const logger = useLogger();

  const { back, stepData, next, userPreferences } = useQuizStep(id);

  const { name } = userPreferences;

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const goNext = async () => next();

  return (
    <>
      {renderQuizScreen({
        goBack,
        goNext,
        name,
        ...(stepData as AboutAppStepData),
      })}
    </>
  );
};

export default AboutAppQuizStep;
